// API Reference: https://fakerjs.dev/api/
import { faker } from "@faker-js/faker";

export const createPhotoShoot = ({
    title = "",
    approved = false,
    isForSinglePhoto = false,
    shootLocation = "",
    description = ""
} = {}) => {
    return {
        id: faker.string.numeric(5),
        createdAt: faker.date.anytime().toString(), // '2022-07-31T01:33:29.567Z'
        approved,
        title,
        isForSinglePhoto,
        shootLocation,
        description,
        __typename: "PhotoShootUploadType"
    };
};
